import { useQuery } from "@tanstack/react-query";
import {
  getClientInfoList,
  getProjectId,
  getProjectLog,
} from "../../api/apiCallManager";

const useProjectLog = () => {
  return useQuery({
    queryKey: ["getProjectLog_", getProjectId()],
    queryFn: getProjectLog,
    enabled: getProjectId() ? true : false,
  });
};

export default useProjectLog;
